export default __webpack_public_path__ + "static/media/268.ed9bb580.jpg";